const frogAsset = (fileName) =>
  `${process.env.REACT_APP_CDN_BASE_URL}/homepage/frogs/${fileName}`;

export const FROG_SCENES = [
  {
    id: 'streamer-auction-peek',
    image: frogAsset('streamer-pepe.webp'),
    imageAspectRatio: 720 / 480,
    animation: 'card-top-peek',
    duration: 5600,
    anchorSelector: '[data-frog-streamer-anchor="auction"]',
    placement: 'top-center',
    width: 250,
    minViewportWidth: 720,
  },
  {
    id: 'streamer-roulette-peek',
    image: frogAsset('streamer-pepe.webp'),
    imageAspectRatio: 720 / 480,
    animation: 'card-top-peek',
    duration: 5600,
    anchorSelector: '[data-frog-streamer-anchor="roulette"]',
    placement: 'top-center',
    width: 250,
    minViewportWidth: 720,
  },
  {
    id: 'streamer-memes-peek',
    image: frogAsset('streamer-pepe.webp'),
    imageAspectRatio: 720 / 480,
    animation: 'card-top-peek',
    duration: 5600,
    anchorSelector: '[data-frog-streamer-anchor="memes"]',
    placement: 'top-center',
    width: 250,
    minViewportWidth: 720,
  },
  {
    id: 'director-side-peek',
    image: frogAsset('director-pepe.webp'),
    imageAspectRatio: 1,
    animation: 'side-peek',
    duration: 5200,
  },
  {
    id: 'rocket-fly-high',
    image: frogAsset('rocket-pepe.webp'),
    imageAspectRatio: 720 / 480,
    animation: 'rocket-fly-high',
    duration: 7200,
  },
  {
    id: 'rocket-fly-low',
    image: frogAsset('rocket-pepe.webp'),
    imageAspectRatio: 720 / 480,
    animation: 'rocket-fly-low',
    duration: 7600,
  },
  {
    id: 'auction-card-pop',
    image: frogAsset('auctioneer-pepe.webp'),
    imageAspectRatio: 1,
    animation: 'card-pop',
    duration: 5400,
    anchorSelector: '[data-frog-anchor="auction"]',
    placement: 'bottom-right',
    width: 210,
    minViewportWidth: 720,
  },
  {
    id: 'roulette-card-conjure',
    image: frogAsset('wizard-pepe.webp'),
    imageAspectRatio: 1,
    animation: 'card-conjure',
    duration: 5800,
    anchorSelector: '[data-frog-anchor="roulette"]',
    placement: 'bottom-left',
    width: 205,
    minViewportWidth: 720,
  },
];

const isAnchorVisible = (scene) => {
  if (!scene.anchorSelector) {
    return true;
  }

  const anchor = document.querySelector(scene.anchorSelector);
  if (!anchor) {
    return false;
  }

  const rect = anchor.getBoundingClientRect();

  if (scene.placement === 'top-center') {
    const actorHeight = scene.width / scene.imageAspectRatio;
    return rect.top > actorHeight * 0.9 + 20
      && rect.top < window.innerHeight - 100;
  }

  return rect.top > 40 && rect.bottom < window.innerHeight - 160;
};

export const getEligibleScenes = (scenes = FROG_SCENES) =>
  scenes.filter((scene) => {
    if (scene.minViewportWidth && window.innerWidth < scene.minViewportWidth) {
      return false;
    }

    return isAnchorVisible(scene);
  });

export const pickNextScene = (scenes, previousSceneId, random = Math.random) => {
  const withoutPrevious = scenes.filter((scene) => scene.id !== previousSceneId);
  const candidates = withoutPrevious.length > 0 ? withoutPrevious : scenes;

  if (candidates.length === 0) {
    return null;
  }

  const index = Math.min(
    candidates.length - 1,
    Math.floor(random() * candidates.length),
  );
  return candidates[index];
};
